<div
  class="celum-avatar_visual-wrap"
  [matTooltip]="configuration.tooltip | translate: configuration.tooltipTranslateParams"
  [style.opacity]="configuration.opacity">
  @if (!imageAvailable) {
    <span
      class="celum-avatar_image celum-avatar_image--none"
      [style.lineHeight.rem]="avatarSize"
      [style.font-size.rem]="configuration.fontSizeInRem ?? avatarPlaceholderFontSize / 10 - 0.2"
      [style.font-weight]="configuration.fontWeight ? configuration.fontWeight : avatarPlaceholderFontSize < 10 ? 600 : 500"
      [style.background-color]="configuration?.backgroundColor"
      [style.border-color]="configuration?.borderColor"
      [style.color]="configuration?.textColor"
      [style.width.rem]="avatarSize"
      [style.height.rem]="avatarSize"
      [style.min-width.rem]="avatarSize"
      title="{{ (configuration?.useHtmlTitleAttribute ? configuration?.title : '') | translate }}">
      @if (configuration?.icon) {
        <celum-icon class="celum-avatar_icon" [configuration]="configuration.icon" [clickable]="false"></celum-icon>
      } @else {
        <span>{{ configuration?.avatarTextPlaceholder ? configuration.avatarTextPlaceholder : avatarTextPlaceholder }}</span>
      }
      @if (configuration?.showOverlay) {
        <span class="celum-avatar_overlay" [style.background-color]="configuration?.overlayColor" (click)="onOverlayClicked($event)">
          <celum-icon [configuration]="configuration?.overlayIcon"></celum-icon>
        </span>
      }
    </span>
  }
  @if (imageAvailable) {
    <span
      class="celum-avatar_image"
      data-private
      [style.backgroundImage]="'url(' + configuration?.image + ')'"
      [style.border-color]="configuration?.borderColor"
      [style.height.rem]="avatarSize"
      [style.lineHeight.rem]="avatarSize"
      [style.min-width.rem]="avatarSize"
      [style.width.rem]="avatarSize"
      title="{{ configuration?.title | translate }}">
      &nbsp;
      @if (configuration?.showOverlay) {
        <span class="celum-avatar_overlay" [style.background-color]="configuration?.overlayColor" (click)="onOverlayClicked($event)">
          <celum-icon [configuration]="configuration?.overlayIcon"></celum-icon>
        </span>
      }
    </span>
  }
  @if ((topLabels$ | async)?.length > 0) {
    <div class="celum-avatar_top-labels">
      @for (label of topLabels$ | async; track label) {
        <celum-icon [configuration]="label"></celum-icon>
      }
    </div>
  }
  @if ((bottomLabels$ | async)?.length > 0) {
    <div class="celum-avatar_bottom-labels">
      @for (label of bottomLabels$ | async; track label) {
        <celum-icon [configuration]="label"></celum-icon>
      }
    </div>
  }
</div>
@if (configuration?.displayName) {
  <div
    class="celum-avatar_name celum-avatar_name--{{ avatarSizeClassName }}"
    [class.celum-avatar_name--inactive]="configuration?.inactive"
    data-private
    spaceAwareTooltip
    [matTooltip]="userName | translate">
    {{ userName | translate }}
  </div>
}
